import React, { useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import styled from 'styled-components';
import { useServiceQuery } from 'generated/graphql';
import Router from 'components/Router/Router';
import Loader from 'components/Loader/Loader';
import AddToHomeScreen from 'components/AddToHomeScreen/AddToHomeScreen';
import PPPortal from 'components/PPPortal/PPPortal';
import { PATH_PREFIX, TEXT_FOOTER_PP } from 'routes/routes';
import useFirebase from 'hooks/useFirebase';

import 'fonts/stylesheet.css';

const AppWrapper = styled.div`
    min-width: 320px;
    max-width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    background-color: #fff;
    font-family: Pragmatica, sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;

function App() {
  const { data, loading } = useServiceQuery();
  const [dangerousText, setDangerousText] = useState('');

  useFirebase();

  useEffect(() => {
    axios.get(`${PATH_PREFIX}${TEXT_FOOTER_PP}`)
      .then((res: AxiosResponse<string>) => {
        if (res.data && res.status === 200) setDangerousText(res.data);
      })
      .catch(() => {});
  }, []);

  if (loading) return <Loader />;

  return (
    <AppWrapper>
      <PPPortal policyText={dangerousText} />
      <Router data={data} />
      <AddToHomeScreen />
    </AppWrapper>
  );
}

export default App;
